<div class="page-container">
  <!-- Linke Seite: Störungen/Geräte -->
  <div class="devices-section">
    <div class="grid-container">
      <div class="card" *ngFor="let device of devices">
        <div class="card-body">
          <!-- Horizontale Anzeige -->
          <div class="horizontal-line">
            <!-- Status anzeigen -->
            <div class="status">
              <span *ngIf="isOnline(device.lastLifeBit) && device.activeFaultCount === 0 && device.edmsFaultCount === 0" class="status-icon online">
                <mat-icon class="symbol">check_circle</mat-icon>
              </span>
              <span *ngIf="!isOnline(device.lastLifeBit) || device.activeFaultCount > 0 || device.edmsFaultCount > 0" class="status-icon offline">
                <mat-icon class="symbol">warning</mat-icon>
              </span>
            </div>

            <!-- Geräte-ID -->
            <div class="card-header">
              <h3>{{ device.deviceId }}</h3>
            </div>

            <!-- Zeitpunkt der letzten Meldung -->
            <div class="last-seen">
              <mat-icon class="symbol">refresh</mat-icon>
              <p> vor {{ formatDate(device.lastLifeBit) }} min</p>
            </div>
          </div>

          
          <!-- Störungsinformationen (unterhalb) -->
          <div *ngIf="device.isFaultActive" class="fault-info">
            <p>Störungen: {{ device.activeFaultCount }}</p>
          </div>

          <!-- EDMS-Störungsinformationen -->
          <div *ngIf="device.edmsFaultCount >= 1" class="edms-fault-info">
            <p><strong>EDMS-Störungen:</strong> {{ device.edmsFaultCount }}</p>
            <p class="affected-instances"><strong>Betroffene Instanzen:</strong> {{ device.affectedInstances }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
<!--

  <div class="employe-card">

    <div class="employee-section">
      <div class="employee-of-month">
        <div class="employee-frame">
          <div class="image-container">
            <img src="../../assets/Manuel.jpg" alt="Urlauber des Monats">
          </div>
          <div class="employee-info">
            <h4>Urlauber des Monats</h4>
            <p>Für Nichtvorhanden sein am Arbeitsplatz!</p>
          </div>
        </div>
      </div>
    </div>

-->




    <!--<div class="employee-section">
      <div class="employee-of-month">
        <div class="employee-frame">
          <div class="image-container">
            <img src="../../assets/Florian.jpg" alt="Mitarbeiter des Monats">
          </div>
          <div class="employee-info">
            <h4>Chefe des Monats</h4>
            <p>Für Voranbringung Tekn-o-logia</p>
          </div>
        </div>
      </div>
      <div class="employee-of-month">
        <div class="loser-frame">
          <div class="image-container">
            <img src="../../assets/ManuelK.jpg" alt="Verlie">
          </div>
          <div class="loser-info">
            <h4>Verlierer des Monats</h4>
            <p>Benötigt keine Begründung</p>
          </div>
        </div>
      </div>
    </div>


    <div class="employee-section">
      <div class="employee-of-month">
        <div class="employee-frame">
          <div class="image-container">
            <img src="../../assets/andi.jpeg" alt="Mitarbeiter des Monats">
          </div>
          <div class="employee-info">
            <h4>Aggressivster Mitarbeiter des Monats</h4>
            <p>Für geiselung durch IT</p>
          </div>
        </div>
      </div>

    </div>
  </div>-->
  </div>
